export default __webpack_public_path__ + "static/media/X8000G6A.bdd2e3b5.png";